import { Controller } from "@hotwired/stimulus"
import { parseNumber, formatNumber } from "../lib/number_helper"

export default class extends Controller {
  static targets = [
    "amountInput",
    "pricePerMwhInput",
    "amountDisplay",
    "netAmountDisplay",
    "priceDisplay",
    "netPriceDisplay",
  ]

  static values = {
    kevSharePercent: { type: Number, default: 0 },
  }

  connect() {
    this.calculateQuarterlyValues()
  }

  calculateQuarterlyValues() {
    const amount = parseNumber(this.amountInputTarget.value)
    const pricePerMwh = parseNumber(this.pricePerMwhInputTarget.value)
    const subsidy = amount * (this.kevSharePercentValue / 100)
    const netAmount = amount - subsidy

    this.amountDisplayTarget.textContent = formatNumber(amount)
    this.netAmountDisplayTarget.textContent = formatNumber(netAmount)
    this.priceDisplayTarget.textContent = formatNumber(pricePerMwh * amount)
    this.netPriceDisplayTarget.textContent = formatNumber(
      pricePerMwh * netAmount,
    )
  }
}
